import { ApplicationController, useDebounce } from 'stimulus-use';

export default class FavoriteListingController extends ApplicationController
{
    static values = {
        url: String,
        isUser: Boolean,
        listingId: String,
    };

    static debounces = [
        '_toggleFavorite',
    ];

    /**
     * @returns {String}
     */
    get url() {
        return this.urlValue;
    }

    get isUser() {
        return this.isUserValue;
    }

    get listingId() {
        return this.listingIdValue;
    }

    get storageKey() {
        return 'favorite_' + this.listingId;
    }

    connect() {
        if (!this.isUser) {
            this._initChecked();
        } else {
            useDebounce(this, {
                wait: 100,
            });
        }
    }

    async favorite() {
        this._toggleState();

        this._toggleFavorite();
    }

    _toggleState(state = null) {
        if (state === null) {
            this.element.ariaChecked = (this.element.ariaChecked !== 'true');
        } else {
            this.element.ariaChecked = state;
        }
    }

    async _toggleFavorite() {
        if (this.isUser) {
            await this._toggleFavoriteUser();
        } else {
            this._toggleFavoriteLocal();
        }
    }

    async _toggleFavoriteUser() {
        const response = await fetch(this.url, {
            method:  'POST',
            headers: {
                'Accept': 'application/json',
            },
        });

        const result = await response.json();

        this._toggleState(result.favorite);
    }

    _toggleFavoriteLocal() {
        const isFavorite = !this._getStoredFavorite();

        if (this._setStoredFavorite(isFavorite)) {
            this._toggleState(isFavorite);
        }
    }

    _initChecked() {
        this.element.ariaChecked = this._getStoredFavorite() ? 'true' : 'false';
    }

    /**
     * @returns {boolean}
     * @private
     */
    _getStoredFavorite() {
        try {
            return localStorage.getItem(this.storageKey) === '1';
        } catch {
        }

        return false;
    }

    /**
     * @param {boolean} favorite
     * @return {boolean} True if set, false otherwise
     * @private
     */
    _setStoredFavorite(favorite) {
        try {
            if (favorite) {
                localStorage.setItem(this.storageKey, '1');
            } else {
                localStorage.removeItem(this.storageKey);
            }

            return true;

        } catch {
            return false;
        }
    }
}
